module.exports = __webpack_public_path__ + "static/media/2_eoru_free_345.c2b472db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2_eoru_free_345.jpg
// module id = 67
// module chunks = 0